module.exports = __webpack_public_path__ + "static/media/Términos_y_condiciones(ES).b2defb60.pdf";